/**
 * @deprecated
 * It's going to be removed in the next major version
 * use RELOADED_ANIMATIONS with the prop animation
 * You have to configure the provider
 */
export var ThirdPartyAnimationVariantType;
(function (ThirdPartyAnimationVariantType) {
    ThirdPartyAnimationVariantType["PRIMARY"] = "PRIMARY";
    ThirdPartyAnimationVariantType["SECONDARY"] = "SECONDARY";
    ThirdPartyAnimationVariantType["SECONDARY_INPUT"] = "SECONDARY_INPUT";
    ThirdPartyAnimationVariantType["TERTIARY"] = "TERTIARY";
    ThirdPartyAnimationVariantType["TERTIARY_ON_SURFACE"] = "TERTIARY_ON_SURFACE";
    ThirdPartyAnimationVariantType["TERTIARY_TECH_ONLY"] = "TERTIARY_TECH_ONLY";
    ThirdPartyAnimationVariantType["CONTACT_CENTER"] = "CONTACT_CENTER";
    ThirdPartyAnimationVariantType["BUBBLE"] = "BUBBLE";
    ThirdPartyAnimationVariantType["CHAT"] = "CHAT";
})(ThirdPartyAnimationVariantType || (ThirdPartyAnimationVariantType = {}));
export var ThirdPartyAnimationSizesType;
(function (ThirdPartyAnimationSizesType) {
    ThirdPartyAnimationSizesType["EXTRA_LARGE"] = "EXTRA_LARGE";
    ThirdPartyAnimationSizesType["LARGE"] = "LARGE";
    ThirdPartyAnimationSizesType["MEDIUM"] = "MEDIUM";
    ThirdPartyAnimationSizesType["SMALL"] = "SMALL";
    ThirdPartyAnimationSizesType["EXTRA_SMALL"] = "EXTRA_SMALL";
})(ThirdPartyAnimationSizesType || (ThirdPartyAnimationSizesType = {}));
//# sourceMappingURL=variants.js.map